var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-white rounded border flex flex-col"},[_vm._t("toolbar"),(!_vm.nocontent)?_c('div',{staticClass:"p-4 w-full m-auto flex flex-col"},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }